// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"632":"baad13b1","693":"809f9c21","964":"59e9430a"}[chunkId] + ".chunk.js";
};